// Necessary Imports
import React, {useState, useEffect, useContext } from "react";
import video_icon from '../images/video_icon.png'
import axios from "axios";
import { Link, useSearchParams, useNavigate  } from 'react-router-dom';
import  SglContext  from "../SglContext";
import Popup from "reactjs-popup";
import VideoPlayer from "../videos/VideoPlayer";

function CircuitPointsDetail(props){

    const Sgl = useContext(SglContext)
    const[searchParam,setSearchParam]=useSearchParams()
    const navigate = useNavigate();


  // States
    const [circuit_division, setCircuit_division] = useState({})
    const [VideoSubscriptionElement, setVideoSubscriptionElement] = useState(null);
    const [circuit, setCircuit] = useState({})
    const [circuit_id, setCircuit_id] = useState(0)
    const [standing, setStanding] = useState({})
    const [circuit_points, setCircuit_points] = useState([])
    const [show_name, setShow_name] = useState('')
    const [person_name, setPerson_name] = useState('')
    const [horse_name, setHorse_name] = useState('')
    const [current_show, setCurrent_show] = useState(localStorage.getItem("show_id"))
    const [loading, setLoading] = useState(true)
    const [userData, setUserData] = useState({})
    const [selection_method,setSelection_method] = useState()
    
    // Video States
    const [is_videos_enabled, setIs_videos_enabled] = useState(false)
    const [videos_list, setVideos_list] = useState([])
    const [video_to_play, setVideo_to_play] = useState({})
    const [playing_video, setPlaying_video] = useState(false)
    const [is_open_play_video_modal, setIs_open_play_video_modal] = useState(false)
    const [is_open_do_subscription_modal, setIs_open_do_subscription_modal] = useState(false)
    const [is_admin, setIs_admin] = useState(false)
    const [VideoPlayerElement, setVideoPlayerElement] = useState(null);



    // Api Endpoints
    
    const sgl_webservice_circuit_standing_detail = Sgl.nestApiUrl+'/results/circuitStanding/';
    const sgl_webservice_video_to_play = Sgl.nestApiUrl+'/videos/play/';
    const user_info_url = Sgl.nestApiUrl+'/users/getUser';

    
 // ComponentDidMount(This will trigger First)
    useEffect(() => {
        getCircuitStandingDetails()
    }, [])

    function getCircuitStandingDetails(){
      getUserData();
      getPointsVideos();
      axios.all([
        axios.get(sgl_webservice_circuit_standing_detail+searchParam.get('div_id')+'/person/'+searchParam.get('pid')+'/horse/'+searchParam.get('hid'),{
            params : {
                circuit_id: searchParam.get('circuit_id'),
                show_id: searchParam.get('sid'),
                customer_id: Sgl.company_id
            }
          }) 
        ]).then(axios.spread((res) => {
          Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/circuitpoints/circuit/'+res.data.circuit_id+'/person/'+res.data.person_name+'/horse/'+res.data.horse_name);
          Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/circuitpoints/circuit/'+res.data.circuit_id+'/person/'+res.data.person_name+'/horse/'+res.data.horse_name);
            setCircuit_division(res.data.circuit_division)
            setCircuit(res.data.circuit)
            setCircuit_id(res.data.circuit_id)
            setStanding(res.data.current_standing)
            setSelection_method(res.data.circuit_division.standingsselectionmethod)
            setCircuit_points(res.data.circuit_points)
            setShow_name(res.data.show_name)
            setPerson_name(res.data.person_name)
            setHorse_name(res.data.horse_name)
            setIs_videos_enabled(res.data.is_videos_enabled)
            setLoading(false)
            document.title = "Results for " + res.data.show_name;

        }))
      }
      function getPointsVideos(){
        axios.get(sgl_webservice_circuit_standing_detail+'videos/'+searchParam.get('div_id')+'/person/'+searchParam.get('pid')+'/horse/'+searchParam.get('hid'),{
          params : {
              circuit_id: searchParam.get('circuit_id'),
              show_id: searchParam.get('sid'),
              customer_id: Sgl.company_id
          }
        })
        .then((res) => {
            setVideos_list(res.data.exc_videos)
        });
      }
      function getUserData(){
        axios.get(user_info_url)
        .then((response) => {
          if(response.data.user && response.data.user != null){
            setUserData(response.data.user)
            if(localStorage.getItem('playing_video_id') && localStorage.getItem('playing_video_url') == window.location.pathname.replace(Sgl.basePath, '') + window.location.search){
              playVideoAPICall(localStorage.getItem('playing_video_id'));  
            }
          }else{
          }
        }, (error) => {
        });
      }
      function getVideosList(uuid){
        var trip = videos_list.find(v => (v.uuid == uuid));
        if(trip) {
          var videos = trip.videos;
          return videos;
        }
        return [];
      }
      function playFirstVideoFromList(uuid){
        var trip = videos_list.find(v => (v.uuid == uuid));
        if(trip) {
          playVideoAPICall(trip.videos[0].sgl_id)
        }
        return;
      }
      const playVideo = (video_id) => (e) => {
        playVideoAPICall(video_id);
      }
      function playVideoAPICall(video_id){
        localStorage.setItem('playing_video_id', video_id);
        localStorage.setItem('playing_video_url', window.location.pathname.replace(Sgl.basePath, '') + window.location.search);
        axios.get(sgl_webservice_video_to_play+video_id,{
          params : {
              customer_id: Sgl.company_id
          }
        })
        .then((res) => {
          closeSubscriptionModal();
          localStorage.removeItem("playing_video_id");
          localStorage.removeItem("playing_video_url");
          if (res.data.subscribed_to_play){
            setVideo_to_play(res.data.video)
            setIs_admin(res.data.is_admin)
            setIs_open_play_video_modal(true)
            setPlaying_video(true)
          } else {
            setVideo_to_play(res.data.video)
            setIs_admin(res.data.is_admin)
            setIs_open_do_subscription_modal(true)
            setPlaying_video(true)

          }
        });
      }
  
      function closeModal() {
        setIs_open_play_video_modal(false)
        setPlaying_video(false)
      }
      function closeSubscriptionModal() {
        setIs_open_do_subscription_modal(false)
        setPlaying_video(false)
        
      }
      function playVideoAfterSubscribe(){
        playVideoAPICall(video_to_play.videos_sgl_id);
        setPlaying_video(true)
      }
      
      function getVideoTitle(video){
        if(video['class_type'] == 'Jumpers'){
          if(video['trip_type'].toLowerCase() != 'jo'){
            return " - Round 1";
          }else{
              return " - Jump Off";
          }
        }
      }

      function onShowChange(show_id) {
        localStorage.setItem('show_id', show_id);
        // window.location.href=page_url;
      }
        const setSelectionMethod = () =>{
            var person_label = 'Rider'
            if (selection_method=="Owner")
                person_label = 'Owner';
            else if (selection_method=="Trainer")
                person_label = 'Trainer';  
            return person_label;
        }
        
        if(loading) {
          return null;
        }
        
        return(
          <div className="section-to-print resultscss">
            <section className="search-area">
              <h2 className="sgl-h2">Results for {show_name}</h2>
              {/* <div><span className='sponsor_text'><b>Standings:</b></span> <a href={page_url}>{circuit.name} : {circuit_division.name}</a></div> */}
              <div><span className='sponsor_text'><b>Standings:</b></span> <Link className="link_color" to onClick={(e)=>{e.preventDefault();navigate('/circuit-standings/')}}>{circuit.name} : {circuit_division.name}</Link></div>
              <div><span className='sponsor_text'><b>Calculated at:</b></span> {circuit_division.lastmodified_date_time_formatted}</div>
              <div><span className='sponsor_text'><b>Calculation Method:</b></span> {circuit_division.standingsbasedon}: {circuit_division.standingscalmethod == 'Linear'?'From Classes':circuit_division.standingscalmethod}</div>
              <div><span className='sponsor_text'><b>Based on:</b></span> {circuit_division.standingsselectionmethod}</div>
              <div><span className='sponsor_text'><b>Standing Position:</b></span>  {standing.position}</div>
              {((selection_method == "Horse")||(selection_method == "Horse/Rider")) &&
                <div><span className='sponsor_text'><b>Horse:</b></span>  {horse_name}</div>
              }
              <div className='sgl-mb-5'><span className='sponsor_text'><b>{setSelectionMethod()}:</b></span>  {person_name}</div>
              

              { (circuit_points.length > 0) ?
              <div className="div-responsive">
                <table className="table table-striped table-hover">
                  <thead className="classes-header">                  
                  
                  <tr className="sgl-primary-header">
                    
                    { (is_videos_enabled == true) &&
                      <th nowrap="nowrap"></th>
                    }
                    <th className="display_row_on_desktop">Show</th>
                    <th className="display_row_on_desktop">Entry</th>
                    <th className='center-align display_row_on_desktop'>Class</th>
                    <th className='center-align display_row_on_desktop'>Placing</th>
                    <th className='center-align display_row_on_desktop'>Points</th>
                    <th className='right-align display_row_on_desktop max_width_55'>Prize Money</th>
                    <th className='center-align display_row_on_desktop'>C/R</th>
                    <th className='center-align display_row_on_mobile'>Circuit Points</th>
                  </tr>
                  </thead>
                  <tbody>
                  {
                    circuit_points.map((data,index) => {
                        return(
                            <tr key={index} className="">
                                { (is_videos_enabled == true) &&
                                  <td>
                                    {(getVideosList(data.entryxclasses_uuid).length > 0) ?
                                      <Popup trigger={<img src={video_icon} className="video-icon" onClick={()=>playFirstVideoFromList(data.entryxclasses_uuid)}/>} on="hover" position="right center">
                                        <div>
                                          <ul className='popup-ul'>
                                            {getVideosList(data.entryxclasses_uuid).map((v_data,index) => { 
                                              return(
                                                <li key={index} className='class_list_li'><a onClick={playVideo(v_data.sgl_id)} >{v_data.class_number} - {v_data.class_name}{getVideoTitle(v_data)}</a></li>
                                              )
                                            })}
                                          </ul>
                                        </div>
                                      </Popup>
                                    :
                                      ''
                                    }
                                  </td>
                                }
                                <td className="display_row_on_mobile mbl_custom_row new-line">
                                  <p className="table_row_p">
                                    <span><strong>Show: </strong>{data.show_name}</span>
                                    <br></br>
                                    <span><strong>Entry: </strong>{data.horse}({data.entry_number})</span>
                                    <br></br>
                                    <span><strong>Class: </strong>{data.class_number} </span>
                                    <br></br>
                                    <span><strong>Placing: </strong> {data.placing} </span>
                                    {/* <br></br> */}
                                    <span className='mr-left-35'><strong>Points: </strong> {data.calculated_points}</span>
                                    <br></br>
                                    <span><strong>Prize Money:</strong> {data.calculated_prize_money} </span>
                                    {/* <br></br> */}
                                    <span className='mr-left-20'>
                                      <strong>C/R: </strong> 
                                      {(data.champ_points > 0)?
                                          data.champ_points+' - C'
                                      :
                                          ((data.reserve_points>0)?data.reserve_points+' - R':' -')
                                      }
                                    
                                    </span>
                                    
                                  </p>
                                </td>
                                <td className="display_row_on_desktop">{data.show_name}</td>
                                <td className="display_row_on_desktop">{data.horse}({data.entry_number})</td>
                                <td className='center-align display_row_on_desktop'>{data.class_number}</td>
                                <td className='center-align display_row_on_desktop'>{data.placing}</td>
                                <td className='center-align display_row_on_desktop'>{data.calculated_points}</td>
                                <td className='right-align display_row_on_desktop'>${data.calculated_prize_money}</td>
                                {(data.champ_points > 0)?
                                    <td className='center-align display_row_on_desktop'>{data.champ_points} - C</td>
                                :
                                    <td className='center-align display_row_on_desktop'>{((data.reserve_points>0)?data.reserve_points+' - R':'-')}</td>
                                }
                            </tr>
                        )
                    })
                  }
                  </tbody>
                </table>
              </div>
              : 
                <table>
                  <tbody>
                    <tr>
                      <td>No records found.</td>
                    </tr>
                  </tbody>
                </table>
              }
              <div>
                {(playing_video) &&
                    <VideoPlayer 
                      is_open_play_video_modal = {is_open_play_video_modal} 
                      is_open_do_subscription_modal = {is_open_do_subscription_modal}
                      is_download_subscription = {false}
                      video_to_play = {video_to_play} 
                      is_admin = {is_admin}
                      closeModal = {closeModal} 
                      closeSubscriptionModal = {closeSubscriptionModal} 
                      playing_preview = {false} 
                      play_video_path = {video_to_play.video_url}
                      playVideoAfterSubscribe = {playVideoAfterSubscribe}
                      VideoSubscriptionElement = {VideoSubscriptionElement}
                      ref = {VideoPlayerElement}
                    />
                }
              </div>
            </section>
          </div>
        )
}
    
export default CircuitPointsDetail